import firebase from 'firebase'

const firebaseConfig = {
    apiKey: "AIzaSyBs4-MreOtFyQ4ACH6JFABLCxXZ5VTj9q0",
    authDomain: "greenbay-booking.firebaseapp.com",
    projectId: "greenbay-booking",
    storageBucket: "greenbay-booking.appspot.com",
    messagingSenderId: "78945406460",
    appId: "1:78945406460:web:e7723f6a78f2811b6bf679"
};

// eslint-disable-next-line no-unused-vars
const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();

export default db;
